import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetSingleProviderVehicle } from '../../../../reduxToolkit/Providers/providersApi';
import { ClearGetSupplierInfoById } from '../../../../reduxToolkit/Providers/providerSlice';
import HeadTittle from '../../../../components/HeadTittle';
import DivContainerBody from '../../../../components/DivContainerBody';
import CreateVehicleApp from './Functionality/CreateVehicleApp';
import routes from '../../../../Routes/routes';
import VehicleFields from './subComponents/VehicleFields';
import { permissionObj } from '../../../../Helpers/permission';
import { useNavigate, useParams } from 'react-router-dom';
import { FILE_TYPE } from '../../../../Helpers/fileType';
import StepperTabs from '../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../components/StepperTabs/StepTab';
import { ButtonNextStep, ButtonPrevStep } from '../../../../components/buttons/ButtonNavigation';
import CustomPhotoPicker from '../../../../components/PhotoPicker/CustomPhotoPicker';
import { ACTION_MODEL } from '../../../../Helpers/ActionModel';
import { SUGGESTION_MODE_OPTION } from '../../../../components/PhotoPicker/SubComponent/Models/Models';
import VehicleSummary from './subComponents/VehicleSummary';
import { TABS_VEHICLE_CREATE } from './model/model';
import VehicleCommons from './Functionality/VehicleCommons';

const CreateVehicle = ({ isUpdate }) => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const navigate = useNavigate();

    // useSelctor state from store slice vehicleSlice
    const { getVehicleStatus } = useSelector((state) => state.VehicleSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    const {
        contractorId,
        supplierId,
        isValid,
        currentTime,
        emptyFields,
        onChange,
        item,
        resetForm,
        handleCreate,
        photoPicker,
        setPhotoPicker,
        activeStep,
        setActiveStep,
        steps,
        handleStepChange,
        handleStepSetUp,
    } = CreateVehicleApp();

    const {handleOnBack}= VehicleCommons();

    useEffect(() => {
        let aux = id || sessionStorage.getItem('vehicleidfordetail');
        if (aux != null && typeof aux != 'undefined') {
            dispatch(GetSingleProviderVehicle(aux));
        }
        return () => {
            dispatch(ClearGetSupplierInfoById());
            resetForm();
        };
    }, []);

    if (!DEV && !permission?.includes(permissionObj?.WEB_VEHICLE_CREATE) && contractorId == null && supplierId == null)
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle
                name={'create'}
                onBack={handleOnBack}
            >
            </HeadTittle>

            <DivContainerBody>
                <>
                    <StepperTabs
                        id={null}
                        disabled={false}
                        steps={steps}
                        activeStep={activeStep}
                        isStepOptional={(step) => step == TABS_VEHICLE_CREATE.PHOTO.INDEX}
                        setActiveStep={setActiveStep}
                        handleStepChange={handleStepChange}
                    >
                        <StepTab index={TABS_VEHICLE_CREATE.DETAILS.INDEX} activeStep={activeStep} normalHeight={true}>
                            <div className='row'>
                                <VehicleFields
                                    item={item}
                                    isUpdate={isUpdate}
                                    vehicle={item}
                                    onChange={onChange}
                                    emptyFields={emptyFields}
                                    getVehicleStatus={getVehicleStatus}
                                    currentTime={currentTime}
                                    isValidModel={isValid}
                                />
                            </div>
                            <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6'>
                                <ButtonNextStep
                                    id='btn_cv_next_vehicle'
                                    text='next'
                                    click={() => {
                                        if (handleStepSetUp()) {
                                            setActiveStep((prevStep) => prevStep + 1);
                                        }
                                    }}
                                />
                            </div>
                        </StepTab>
                        <StepTab index={TABS_VEHICLE_CREATE.PHOTO.INDEX} activeStep={activeStep} normalHeight={true}>
                            <CustomPhotoPicker
                                id='fp_cv_create_photo_file'
                                photoPicker={photoPicker}
                                setPhotoPicker={setPhotoPicker}
                                actionModel={ACTION_MODEL.CREATE}
                                accept={{ ...FILE_TYPE.IMAGE }}
                                showBtnCamera={false}
                                validateFace={false}
                                classWith={'content-center-w-400px'}
                                showPreview={true}
                                typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE}
                            />

                            <div className='d-flex justify-content-between px-0 mt-3'>
                                <ButtonPrevStep
                                    id='btn_cv_back_file'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_cv_next_file'
                                    text='next'
                                    disabled={activeStep === steps.length - 1}
                                    click={() => setActiveStep((prevStep) => prevStep + 1)}
                                />
                            </div>
                        </StepTab>
                        <StepTab index={TABS_VEHICLE_CREATE.SUMMARY.INDEX} activeStep={activeStep} normalHeight={true}>
                            <VehicleSummary item={item} photoPicker={photoPicker} />
                            <div className='d-flex justify-content-between px-0 mb-2'>
                                <ButtonPrevStep
                                    id='btn_cv_back_summary'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_cv_enroll'
                                    text='create'
                                    click={() => {
                                        handleCreate();
                                    }}
                                />
                            </div>
                        </StepTab>
                    </StepperTabs>
                </>
            </DivContainerBody>
        </>
    );
};

export default CreateVehicle;
